import React from "react";

import { colorPalette } from "../utils/consts";
import CompanyHeader from "./CompanyHeader";
import WherebyMeetingEmbed from "./WherebyMeetingEmbed";
import CalendarView from "./CalendarView";
import SideTabs from "./SideTabs";

const ReceptionistControlRoom = ({
  sidebarCollapsed,
  meetingLink,
  companyProfile,
  companyId,
  userProfile,
  role,
  hosts,
  receptionAttendeesList,
  onLeaveMeeting = () => {},
}) => {
  return (
    <div className="row h-100">
      <div className="col-sm-12 col-md-8 col-xl-9">
        <div className="header text-center text-uppercase my-3">
          <CompanyHeader profile={companyProfile} />
        </div>

        <WherebyMeetingEmbed
          meetingLink={meetingLink}
          companyProfile={companyProfile}
          companyId={companyId}
          role={role}
          onClickLeaveMeeting={onLeaveMeeting}
        />

        <div className="card my-3 shadow">
          <div className="card-body">
            <CalendarView
              colorPalette={colorPalette}
              AllUsers={hosts}
              CompanyProfileID={companyProfile.CompanyProfileID}
              userProfile={userProfile}
            />
          </div>
        </div>
      </div>

      <div className="col-sm-12 col-md-4 col-xl-3 px-0">
        <SideTabs
          sidebarCollapsed={sidebarCollapsed}
          attendees={receptionAttendeesList}
          attendeesTabLabel="Attendees"
          chatTabLabel="Chat"
          showAttendeesTab={true}
          ShowChatTab={true}
        />
      </div>
    </div>
  );
};

export default ReceptionistControlRoom;
